<template>
<div class="nj-input-help">
    <Button title="Info" type="icon" icon="info" @click="active($event)"></Button>
    <div v-if="isActive" class="nj-input-help--message">
        <slot></slot>
    </div>
</div>
</template>
<script>
import Button from "./Button.vue"
export default {
    name: "Help",
    props: {

    },
    components: {
        Button
    },
    data() {
        return {
            isActive: false
        }
    },
    methods: {
        active(event) {
            event.stopPropagation()
            this.isActive = true
        }
    },
    mounted() {
        window.addEventListener("click", () => {
            this.isActive = false
        })
    },
}
</script>

<style scoped>
.nj-input-help {
    position: relative;
}

.nj-input-help--message {
    width: 100%;
    min-width: 200px;
    position: absolute;
    background-color: #666;
    color: #fff;
    padding: 12px;
    margin: 4px 0 0 0;
    text-align: left;
    border-radius: var(--radius);
}
</style>